import {
  DataTableColumnBadgeProps,
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { PaaRepository } from '../../../../store/paa-state/paa-state.repository';

interface getPaaHistoryDataTableStructureProps {
  store: PaaRepository;
  rowActions?: DataTableRowActions;
  serverQuery?: DataTableServerQuery;
}

export const getPaaHistoryDataTableStructure = ({ store, rowActions, serverQuery }: getPaaHistoryDataTableStructureProps): DynamicDataTable => {
  const refColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'paa.table.ref',
    accessorKey: 'ref',
    variant: DataTableColumnVariant.TEXT,
  };

  const nomColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'paa.table.name',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
    class: 'truncate w-[10vw] min-w-0',
  };

  const processStepColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'paa.table.processStep',
    accessorKey: 'etapeProcess',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      if (!value) return { value: 'Non défini', class: 'opacity-70' };
      return { value };
    },
  };

  const anneeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'paa.table.year',
    accessorKey: 'annee',
    variant: DataTableColumnVariant.TEXT,
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'paa.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: string) => {
      return {
        value: `paa.status.${value}`,
      };
    },
    props: {
      getSeverity: (value: string) => {
        if (value === 'BROUILLON') return 'primary';
        if (value === 'EN_TRAITEMENT') return 'contrast';
        if (value === 'VALIDE') return 'success';
        if (value === 'PUBLIE') return 'info';
        return 'danger';
      },
    },
  };

  const budgetColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.budget',
    accessorKey: 'budgetEstime',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: number) => {
      if (value) {
        return { value: value };
      }
      return { value: 'Non défini', class: 'opacity-70' };
    },
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'paa.table.created_at',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const updatedAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'paa.table.updated_at',
    accessorKey: 'metadata.updatedAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const acColumnn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'paa.table.ac',
    accessorKey: 'ac.nom',
    variant: DataTableColumnVariant.TEXT,
  };

  return {
    singular: "Historique des Plans d'Achats",
    plural: "Historiques des Plans d'Achats",
    columns: [refColumn, anneeColumn, nomColumn, acColumnn, statusColumn, processStepColumn, budgetColumn, createdAtColumn, updatedAtColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => {
      store.setNested('response', row);
    },
    enableServerActions: true,
    serverQuery,
    rowActions,
    searchableFields: ['ref', 'nom', 'annee', 'status'],
  };
};
